import React, { useState } from "react";
import { Fingerprint, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { enableBio, dismissBio } from "@/lib/biometric";

export const BiometricOfferDialog = ({ open, onDone }) => {
  const [busy, setBusy] = useState(false);
  const activate = async () => {
    setBusy(true);
    const r = await enableBio();
    setBusy(false);
    if (r.ok) toast.success("Pronto! Na próxima vez entre com Face ID ou digital.");
    else toast.error(r.error);
    onDone();
  };
  const skip = () => { dismissBio(); onDone(); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) skip(); }}>
      <DialogContent className="max-w-sm rounded-3xl" data-testid="bio-offer-dialog">
        <DialogHeader className="items-center text-center">
          <div className="w-16 h-16 rounded-2xl bg-violet-100 flex items-center justify-center mb-2"><Fingerprint className="w-9 h-9 text-[#7c3aed]" /></div>
          <DialogTitle className="font-heading text-[#1e3a8a]">Entrar com Face ID ou digital?</DialogTitle>
          <DialogDescription>Ative neste celular e entre sem digitar a senha. A senha continua valendo e a biometria fica só neste aparelho.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 mt-2">
          <Button onClick={activate} disabled={busy} data-testid="bio-offer-enable" className="h-11 rounded-xl bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-semibold">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Fingerprint className="w-4 h-4 mr-1" />} Ativar biometria
          </Button>
          <Button variant="ghost" onClick={skip} disabled={busy} data-testid="bio-offer-skip" className="h-10 rounded-xl">Agora não</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
